<template>
  <v-container fluid>

    <!-- 참가자 정보 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_user" @keydown.esc="dialog_user = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('common_userinfo_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_user = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field v-model="visitorItem.IDX" :label="$t('eul_col2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="visitorItem.COM_NAME" :label="$t('common_userinfo_label2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="visitorItem.EVENT_NAME" :label="$t('common_userinfo_label3')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field :value="$i18n.locale === 'ko' ? visitorItem.OPTION_NAME : visitorItem.OPTION_NAME_ENG" :label="$t('common_userinfo_label4')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-text-field v-model="visitorItem.REGTYPE_NAME" :label="$t('common_userinfo_label18')" disabled></v-text-field>
              </v-row>

              <!-- 행사별 커스텀 기본정보 -->              
              <template v-for="item in infoItem">
                <template v-if="item.USETYPE == 1">
                  <template v-if="item.LANTYPE == 4">
                    <v-row dense :key="item.INPUT_CODE">
                      <label style="color:rgba(0,0,0,0.38)">{{item.NAME}}</label>
                    </v-row>
                    <template v-if="visitorItem['INFO'+item.INPUT_CODE] != null && visitorItem['INFO'+item.INPUT_CODE] != undefined && visitorItem['INFO'+item.INPUT_CODE].length > 1">
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <img  :height="item.HEIGHT" :width="item.WIDTH" :src="visitorItem['INFO'+item.INPUT_CODE]" class="image"/>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <label style="color:rgba(0,0,0,0.38)">{{$t('common_userinfo_label5')}}</label>
                      </v-row>
                    </template>
                  </template>

                  <template v-else-if="item.LANTYPE == 5">
                    <v-row dense :key="item.INPUT_CODE">
                      <label style="color:rgba(0,0,0,0.38)">{{item.NAME}}</label>
                    </v-row>
                    <template v-if="visitorItem['INFO'+item.INPUT_CODE] != null && visitorItem['INFO'+item.INPUT_CODE] != undefined && visitorItem['INFO'+item.INPUT_CODE].length > 1">
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <a :href="visitorItem['INFO'+item.INPUT_CODE]" download target="_blink">File Download</a>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <label style="color:rgba(0,0,0,0.38)">{{$t('common_userinfo_label19')}}</label>
                      </v-row>
                    </template>
                  </template>

                  <template v-else>
                    <template v-if="item.MAXLINES == 1">
                      <v-row dense  :key="item.INPUT_CODE">
                        <v-textarea dense no-resize outlined height="70"
                        v-if="item.USETYPE == 1" v-model="visitorItem['INFO'+item.INPUT_CODE]" :label="item.NAME" disabled></v-textarea>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense  :key="item.INPUT_CODE">
                        <v-text-field v-if="item.USETYPE == 1" v-model="visitorItem['INFO'+item.INPUT_CODE]" :label="item.NAME" disabled></v-text-field>
                      </v-row>
                    </template>
                  </template>
                </template>
              </template>

              <v-row dense v-if="useInfo.USETEL == 1">
                  <v-text-field v-model="visitorItem.TEL" :label="$t('common_userinfo_label6')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USEMAIL == 1">
                  <v-text-field v-model="visitorItem.EMAIL" :label="$t('common_userinfo_label7')" disabled></v-text-field>
              </v-row>

              <v-row dense v-if="useInfo.USEPW == 1">
                  <v-text-field v-model="visitorItem.PRINT_NUMBER" :label="$t('common_userinfo_label8')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USESEX == 1">
                  <v-text-field v-model="visitorItem.SEX_NAME" :label="$t('common_userinfo_label9')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USEYEAR == 1">
                  <v-text-field v-model="visitorItem.YEAR" :label="$t('common_userinfo_label10')" counter="4" :suffix="$t('common_userinfo_label13')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USENATION == 1">
                  <v-text-field v-model="visitorItem.NAMEKOR" :label="$t('common_userinfo_label12')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="visitorItem.STATE_NAME" :label="$t('common_userinfo_label13')" disabled></v-text-field>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_user = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>    

    <!-- 출력수 수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="cnt_dialog" @keydown.esc="cnt_dialog = false" max-width="600px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('vpllist_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="cnt_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense class="mt-5">
                <v-text-field disabled v-model="editedItem.NAME" :label="$t('vpllist_col4')"/>
              </v-row>
              <v-row dense class="mt-5">
                <v-text-field :rules="numberrules" v-model="editedItem.CNT" :label="$t('vpllist_col8')"/>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="cnt_dialog = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row dense align="center" justify="space-between" no-gutters>
      <v-col cols="12" md="2" sm="12" xs="12" class="pa-0">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <template v-if="grade >= 50">
        <v-col  cols="12" offset-md="4" md="3" sm="12" xs="12">
          <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
        <v-col cols="12" md="3" sm="12" xs="12">
          <devicedialog :eventname="SEARCH_DEVICE_NAME" :comidx="SEARCH_COM_IDX" @callback="devicesearchcb"></devicedialog>
        </v-col>
      </template>
      <template v-else>
        <v-col cols="12" offset-md="4" md="3" sm="12" xs="12">
          <devicedialog :eventname="SEARCH_DEVICE_NAME" :comidx="SEARCH_COM_IDX" @callback="devicesearchcb"></devicedialog>
        </v-col>
      </template>
    </v-row>

    <v-row align="center" dense>
      <v-spacer/>
      <v-col cols="6" md="2" sm="6" xs="6" class="pa-0">
        <v-menu
          v-model="date1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_start_date"
              :label="$t('common_search_start')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_start_date" @input="date1 = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>      
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" class="pa-0">
        <v-menu
          v-model="date2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_end_date"
              :label="$t('common_search_end')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_end_date" @input="date2=false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>                    
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="search_run">{{$t("common_ok")}}</v-btn>
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" align="center" class="pa-0">
        <v-btn style="width:94%" color="#4e6ef7" large rounded  @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn>
      </v-col>
      
    </v-row>

  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>

  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >
        <template v-slot:header.ACCNT>
          <label class="cheader_normal">{{$t("deviceadmin_col1")}}</label>
        </template>
        <template v-slot:header.EVENT_NAME>
          <a :class="sort_name=='EVENT_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('EVENT_NAME')">{{$t("vpllist_col1")}}</a>
        </template>
        <template v-slot:header.OPTION_NAME>
          <a :class="sort_name=='OPTION_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('OPTION_NAME')">{{$t("vpllist_col2")}}</a>
        </template>
        <template v-slot:header.USER_TYPENAME>
          <a :class="sort_name=='USER_TYPENAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('USER_TYPENAME')">{{$t("vpllist_col3")}}</a>
        </template>
        <template v-slot:header.NAME>
          <a :class="sort_name=='NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('NAME')">{{$t("vpllist_col4")}}</a>
        </template>
        <template v-slot:header.TEL>
          <a :class="sort_name=='TEL'?'cheader_sortselect':'cheader_sort'" @click="customsort('TEL')">{{$t("vpllist_col5")}}</a>
        </template>
        <template v-slot:header.PRINT_DATE>
          <a :class="sort_name=='PRINT_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('PRINT_DATE')">{{$t("vpllist_col6")}}</a>
        </template>
        <template v-slot:header.PRINT_TYPE>
          <label class="cheader_normal" >{{$t("vpllist_col7")}}</label>
        </template>
        <template v-slot:header.CNT>
          <a :class="sort_name=='CNT'?'cheader_sortselect':'cheader_sort'" @click="customsort('CNT')">{{$t("vpllist_col8")}}</a>
        </template>
        <template v-slot:header.delete>
          <label class="cheader_normal" >{{$t("vpllist_col9")}}</label>
        </template>

        <template v-slot:item.NAME="{ item }">  
          <a @click="loadvisitor(item.VISITOR_IDX, item.EVENT_IDX)" >{{item.NAME}}</a>
        </template>

        <template v-slot:item.OPTION_NAME="{ item }">  
          <label>{{ $i18n.locale === 'ko' ? item.OPTION_NAME : item.OPTION_NAME_ENG }}</label>
        </template>

        <template v-slot:item.CNT="{ item }">  
          <template v-if="grade > 90">
            <a @click="edit_item(item)">{{item.CNT}}</a>
          </template>
          <template v-else>
            <div>{{item.CNT}}</div>
          </template>
        </template>

        <template v-slot:item.delete="{item}">
          <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>

      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" style="font-size:16px" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn style="font-size:16px" color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn class="font-size:16px" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" style="font-size:16px" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  </v-container>
</template>
<script>

import moment from 'moment'
import XLSX from 'xlsx'

export default {

  beforeDestroy(){

  },

  mounted(){

    if(this.$session.get("GRADE") < 10){
      this.$alert(this.$t("common_nograde"));
      this.$router.push("Login");
      return;
    }

    this.numberrules = [v => Number.isInteger(Number(v)) || this.$t('common_numberrules')],

    this.SEARCH_COM_IDX     = this.$session.get("COM_IDX");
    this.SEARCH_COM_NAME    = this.$session.get("COM_NAME");
    this.SEARCH_DEVICE_IDX  = this.$session.get("DEVICE_IDX");
    this.SEARCH_DEVICE_NAME = this.$session.get("DEVICE_NAME");
    
    this.grade = this.$session.get("GRADE");
    
    if(this.grade > 90){
      this.headers.push({text: '삭제', value: 'delete', sortable: false, align:'center' });
    }

    this.search_start_date  = this.$session.get("EVENT_START");
    if(this.search_start_date == null || this.search_start_date == undefined || this.search_start_date == 'Invalid date'){
      this.search_start_date = moment().subtract(1, 'YEARS').format("YYYY-MM-DD");
    }
    this.search_end_date    = this.$session.get("EVENT_END");
    if(this.search_end_date == null || this.search_end_date == undefined || this.search_end_date == 'Invalid date'){
      this.search_end_date   = moment().format("YYYY-MM-DD");
    }

    if(this.$session.exists("ADMIN_IDX")){
      this.initpage();
    }else{
      //키값 없으면 로그인으로
      this.$router.push("Login");
    }
  },

  data: () => ({
    useInfo:{},
    //필수 페이징 파라메터
    totalcnt : 0,       //전체 아이템 개수
    page : 0,
    maxpage : 0,        //전체 페이지 개수
    startpage : 1,      //시작 인덱스
    bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
    subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
    loading : false,    //로딩 표시

    //테이블 정의
    headers: [
      {text: '장비명', value: 'ACCNT', sortable: false, align:'center' },
      {text: '행사명', value: 'EVENT_NAME', sortable: false, align:'center' },
      {text: '등록 카테고리', value: 'OPTION_NAME', sortable: false, align:'center'},
      {text: '회원', value: 'USER_TYPENAME', sortable: false, align:'center'},
      {text: '이름', value: 'NAME', width:200, sortable: false, align:'center' },
      {text: '전화번호', value: 'TEL', sortable: false, align:'center' },
      {text: '출력일시', value: 'PRINT_DATE', sortable: false, align:'center' },
      {text: '출력타입', value: 'PRINT_TYPE', sortable: false, align:'center' },
      {text: '출력수', value: 'CNT', sortable: false, align:'center' },
    ],
    itemList: [],

    sort_name: 'PRINT_DATE',
    sort_type: true,    //true : DESC, false: ASC

    search_keyword : '',
    search: '',         //필터링용 검색어

    //한 페이지 ROW 개수 설정
    pagerow : 20,       //한 페이지에 보여줄 row수
    pagerow_combo : [
        {NAME:'20', VALUE:20}
      , {NAME:'50', VALUE:50}
      , {NAME:'100', VALUE:100}
      , {NAME:'200', VALUE:200}
    ],    
    
    cnt_dialog:false,
    numberrules: null,
    editedItem: {
    },

    date1:false,
    date2:false,
    search_start_date : '',
    search_end_date : '',
    
    list:[],

    SEARCH_COM_IDX: null,
    SEARCH_COM_NAME: '',
    SEARCH_DEVICE_IDX: null,
    SEARCH_DEVICE_NAME: '',
    grade : 0,

    dialog_user:false,    
    visitorItem: {},
    infoItem:[],    //행사별 기본접수양식 커스텀 정보 

  }),

  methods: {


    //아이템 수정
    edit_item(item){
      
      if(this.SEARCH_COM_IDX == null){
        this.$alert(this.$t('common_search_tcom'));
        return;
      }
      //this.editedItem = item;
      this.editedItem = Object.assign({}, item);
      this.cnt_dialog = true;
    },

    //수정
    save () {

      const numberVal1 = /[^0-9]/g;
      if(this.editedItem.CNT == null || this.editedItem.CNT == undefined || String(this.editedItem.CNT).length < 1){
        this.$alert(this.$t('vpllist_msg1'));
        return;
      } 
      if(numberVal1.test(this.editedItem.CNT)){
        this.$alert(this.$t('vpllist_msg2'));
        return;
      } 

      //수정
      this.$http.post(this.$host+'/api/VisitorPrintCntUpdate',{
            PRINT_IDX: this.editedItem.IDX
          , ADMIN_IDX: this.editedItem.ADMIN_IDX
          , CNT: this.editedItem.CNT
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
        if(result.data.resultCode == 0){
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            this.$alert(this.$t("common_edit_msg")).then(()=>{
              const p = this.page;
              this.page = 0;
              this.loadpage(p);
            });

        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동

        }else{
            this.$alert(this.$t("common_edit_fail"));
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        this.$alert(this.$t("common_edit_fail"));
      });
      this.close();
    },      

    //다이얼로그 닫기
    close () {
      this.cnt_dialog = false
      setTimeout(() => {
        this.editedItem = {};
      }, 300)
    },



      //아이템 삭제
      delete_item(item){
        
        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/VisitorPrintDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },
    

    insertAt(array, index, item) {
      array.splice(index, 0, item);
    },

    startDownload(){

        this.$confirm(this.$t('common_search_downexcel')).then(() => {

          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          if(this.search_start_date.length < 4){
            this.$alert(this.$t('common_search_start_info1'));
            return;
          }
          if(this.search_end_date.length < 4){
            this.$alert(this.$t('common_search_end_info1'));
            return;
          }
          if(this.search_start_date > this.search_end_date){
            this.$alert(this.$t('common_search_date_error1'));
            return;
          }        
          
          
          this.loading = true;
          this.$http.post(this.$host+'/api/KioskPrintListExcel',{
              search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
            , sort_name:this.sort_name
            , sort_type: this.sort_type==true ? "DESC" : "ASC" 
            , ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , KIOSK_IDX: this.SEARCH_DEVICE_IDX
            , COM_IDX: this.SEARCH_COM_IDX
            , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
            , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
            , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                
                const list = result.data.resultData;
                var item_sheet = XLSX.utils.json_to_sheet(list);

                //컬럼명 수정
                item_sheet.A1 = {v:this.$t('deviceadmin_col1')};
                item_sheet.B1 = {v:this.$t('vpllist_excel1')};
                item_sheet.C1 = {v:this.$t('vpllist_excel2')};
                item_sheet.D1 = {v:this.$t('vpllist_excel3')};
                item_sheet.E1 = {v:this.$t('vpllist_excel4')};
                item_sheet.F1 = {v:this.$t('vpllist_excel5')};
                item_sheet.G1 = {v:this.$t('vpllist_excel6')};
                item_sheet.H1 = {v:this.$t('vpllist_excel7')};
                item_sheet.I1 = {v:this.$t('vpllist_excel8')};
                
                //컬럼별 너비
                var wscols = [{wch:30},{wch:20},{wch:10},{wch:10},{wch:10},{wch:20,},{wch:20},{wch:15},{wch:15},{wch:10}];
                item_sheet['!cols'] = wscols;

                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('vpllist_msg3'));
                XLSX.writeFile(wb, this.$t('vpllist_msg4')+moment().format('YYYYMMDDHHmmss')+'.xlsx');


            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

        });
    },

    initpage(){
      //첫페이지 로드
      this.loadpage(1);
    },

    loadpage(p){

      if(this.SEARCH_COM_IDX == null){
        this.$alert(this.$t('common_select_tcom'));
        return;
      }

      if(this.SEARCH_DEVICE_IDX == null || this.SEARCH_DEVICE_IDX == undefined || this.SEARCH_DEVICE_IDX == ""){
        this.$alert(this.$t('devicedialog_msg1'));
        return;
      }
      
      if(this.search_start_date.length < 4){
        this.$alert(this.$t('common_search_start_info1'));
        return;
      }
      if(this.search_end_date.length < 4){
        this.$alert(this.$t('common_search_end_info1'));
        return;
      }
      if(this.search_start_date > this.search_end_date){
        this.$alert(this.$t('common_search_date_error1'));
        return;
      }        
      
      this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      this.loading = true;
      this.page = p;

      this.$http.post(this.$host+'/api/KioskPrintList',{
            search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
          , sort_name:this.sort_name
          , sort_type: this.sort_type==true ? "DESC" : "ASC" 
          , page: this.page
          , pagerow: this.pagerow
          , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , KIOSK_IDX: this.SEARCH_DEVICE_IDX
          , COM_IDX: this.SEARCH_COM_IDX
          , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
          , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
          , LAN_CODE:this.$i18n.locale
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
        
        if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            this.totalcnt = result.data.totalcnt;
            this.makepaging();
            const list = result.data.resultData;
            list.forEach(element => {
                this.itemList.push(element); 
            });

            this.loading = false;

        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.loading = false;
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동

        }else{
          this.loading = false;
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        this.loading = false;
        if(error.message == 'Request failed with status code 429')
        {
          this.$alert(this.$t("common_reqer"));
        }else{
          this.$alert(error.message);
        }
      });

    },    

    search_run(){

      this.loadpage(1);

    },

    loadvisitor(vidx, eidx){

        this.$http.post(this.$host+'/api/VisitorDetail',{
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , EVENT_IDX: eidx
            , VISITOR_IDX: vidx
            , LAN_CODE:this.$i18n.locale
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData;
              this.visitorItem = list[0];
              this.dialog_user = true;

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          
        });

    },          


    customsort(sortname){
      this.sort_name = sortname;
      this.sort_type = !this.sort_type;
      this.loadpage(this.page);
    },

    prev(){
        this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
        this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
        this.loadpage(temp_page);
    },
    next(){
        this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
        this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        var temp_page = this.bottompage;
        this.loadpage(temp_page);
    },

    makepaging(){
      var div1 = this.totalcnt / this.pagerow; 
      var div2 = this.totalcnt % this.pagerow;
      if(div2 == 0){  
          this.maxpage = parseInt(div1);    
      }else{
          this.maxpage = parseInt(div1+1);
      }
      if(this.bottompage == 1){
        this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
      }
    },


    //검색조건 업체 설정
    devicesearchcb(val1){
      if(val1 != null || val1 != undefined || val1.ACCNT.length > 0){
        this.SEARCH_DEVICE_NAME = val1.ACCNT;
        this.SEARCH_DEVICE_IDX  = val1.IDX;

        this.$session.set("DEVICE_IDX", val1.IDX);
        this.$session.set("DEVICE_NAME",val1.NAME);

      }else{
        this.SEARCH_DEVICE_NAME = "";
        this.SEARCH_DEVICE_IDX  = null;
        
        this.$session.set("DEVICE_IDX", null);
        this.$session.set("DEVICE_NAME", "");

      }
      this.search_run();
    },

    // eslint-disable-next-line no-unused-vars
    comsearchclear(var2){
        this.SEARCH_COM_IDX    = null;
        this.SEARCH_COM_NAME   = '';
        this.SEARCH_DEVICE_IDX  = null;
        this.SEARCH_DEVICE_NAME = '';
        
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("DEVICE_IDX", null);
        this.$session.set("DEVICE_NAME", "");

        this.search_run();
    },

    //업체선택 콜백
    comdialogcb(val){
      if(val.NAME.length > 0){
        this.editedItem.COM_NAME = val.NAME;
        this.editedItem.COM_IDX  = val.IDX;
      }else{
        this.$alert(this.$t('common_select_company'));
        return;
      }
    },

    //검색조건 업체 설정
    comsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_COM_NAME = val1.NAME;
        this.SEARCH_COM_IDX  = val1.IDX;
        this.$session.set("COM_IDX", val1.IDX);
        this.$session.set("COM_NAME", val1.NAME);
        this.SEARCH_DEVICE_IDX = null;
        this.SEARCH_DEVICE_NAME = '';
        this.$session.set("DEVICE_IDX", null);
        this.$session.set("DEVICE_NAME", "");
      }else{
        this.SEARCH_COM_NAME = '';
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_DEVICE_IDX = null;
        this.SEARCH_DEVICE_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("DEVICE_IDX", null);
        this.$session.set("DEVICE_NAME", "");
        
      }
      this.search_run();
    },



  }
    
}

</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>